"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _helpers = require("../../utils/helpers");
var _NavList = _interopRequireDefault(require("../lists/NavList"));
var _LogoNavigation = _interopRequireDefault(require("./LogoNavigation"));
var _ImageReplacementAnchor = _interopRequireDefault(require("../utils/ImageReplacementAnchor"));
var _Overlay = _interopRequireDefault(require("../utils/Overlay"));
var _DrawerNavigationModule = _interopRequireDefault(require("./../../scss/navigations/DrawerNavigation.module.scss"));
function DrawerNavigation({
  links = [],
  items = [],
  classname = '',
  logo = {},
  clipPathStart = 'circle(0% at top right)',
  clipPathEnd = 'circle(250% at top right)',
  overlayAppendEl = document.querySelector('#root')
}) {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [animationState, setAnimationState] = (0, _react.useState)(null);
  const bodyEl = document.querySelector('body');
  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setAnimationState('closing');
    if (isOpen) {
      const overlayEl = document.querySelector('#overlay');
      overlayEl === null || overlayEl === void 0 ? void 0 : overlayEl.setAttribute('data-state', 'exiting');
      setTimeout(() => {
        overlayEl === null || overlayEl === void 0 ? void 0 : overlayEl.remove();
        bodyEl.style.overflowY = 'auto';
      }, 400);
    } else {
      bodyEl.style.overflowY = 'hidden';
    }
  };
  const handleAnimationEnd = () => {
    if (!isOpen) {
      setAnimationState(null);
    }
  };
  document.addEventListener('scripps:overlay:closed', toggleMenu);
  return (
    /*#__PURE__*/
    // Ideally the parent for this component will be a <nav> for accessibility reasons
    _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _helpers.classes)([_DrawerNavigationModule.default['drawer-navigation__nav-bar'], 'drawer-navigation__nav-bar', logo.image && _DrawerNavigationModule.default['with-logo'], `drawer-navigation__nav-bar--${isOpen ? 'expanded' : animationState ? 'closing' : 'closed'}`])
    }, logo.image && /*#__PURE__*/_react.default.createElement(_ImageReplacementAnchor.default, {
      href: logo.href,
      image: logo.image,
      height: logo.height,
      baselineAdjustment: logo.baselineAdjustment
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _helpers.classes)([_DrawerNavigationModule.default['drawer-navigation__menu-toggle'], 'drawer-navigation__menu-toggle']),
      "aria-controls": "drawer-navigation__primary-navigation",
      "aria-expanded": isOpen,
      onClick: toggleMenu
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: _DrawerNavigationModule.default['visually-hidden']
    }, "Menu"), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _helpers.classes)([_DrawerNavigationModule.default['drawer-navigation__hamburger'], 'drawer-navigation__hamburger']),
      "aria-hidden": "true"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _helpers.classes)([_DrawerNavigationModule.default['drawer-navigation__primary-navigation'], 'drawer-navigation__primary-navigation']),
      id: "drawer-navigation__primary-navigation",
      "data-state": isOpen ? 'opened' : animationState || 'closed',
      onAnimationEnd: handleAnimationEnd,
      style: {
        '--clip-path-start': clipPathStart,
        '--clip-path-end': clipPathEnd
      }
    }, links.length > 0 && /*#__PURE__*/_react.default.createElement(_NavList.default, {
      links: links,
      classname: classname
    }), items.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", {
      className: (0, _helpers.classes)([_DrawerNavigationModule.default['drawer-navigation__separator'], 'drawer-navigation__separator'])
    }), /*#__PURE__*/_react.default.createElement(_LogoNavigation.default, {
      items: items
    }))), isOpen && /*#__PURE__*/_react.default.createElement(_Overlay.default, {
      appendToElement: overlayAppendEl,
      state: animationState === null && !isOpen ? `exiting` : `entering`
    }))
  );
}
var _default = exports.default = DrawerNavigation;